import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCampaigns } from '../services/api'; // Use your API file

export const getCampaigns = createAsyncThunk(
    'campaigns/getCampaigns',
    async (params = {}) => {
        const response = await fetchCampaigns(params);
        return response.data;
    }
);

const campaignSlice = createSlice({
    name: 'campaigns',
    initialState: {
        campaigns: [],  // Storing open calls here
        status: 'idle',
        error: null,
        pagination: {
            limit: 10,
            offset: 0,
            totalCount: 0,
        },
    },
    reducers: {},
    extraReducers: {
        [getCampaigns.pending]: (state) => {
            state.status = 'loading';
        },
        [getCampaigns.fulfilled]: (state, action) => {
            state.campaigns = action.payload.data;
            state.pagination = {
                limit: action.payload.limit,
                offset: action.payload.offset,
                totalCount: action.payload.totalCount,
            };
            state.status = 'succeeded';
        },
        [getCampaigns.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        },
    },
});

export default campaignSlice.reducer;